import React, {PropTypes} from 'react';


function EditIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width="30px" height="30px" viewBox="0 0 30 30" version='1.1' xmlns='http://www.w3.org/2000/svg' className={`profile-icon ${className}`} {...otherProps}>
      <g id="1160---Upload-of-Assessment-Scores" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-790.000000, -438.000000)" id="Group-28" fill="#4A4A4A">
            <g transform="translate(331.000000, 275.000000)">
                <g id="Group-37" transform="translate(459.000000, 163.000000)">
                    <g id="icon_pencil">
                        <g id="Group-30">
                            <g id="Icons" transform="translate(7.000000, 7.000000)">
                                <g id="Group">
                                    <path d="M11.9251613,7.11741935 C11.7930323,7.11741935 11.6609032,7.06683871 11.5602581,6.96619355 C11.3584516,6.7643871 11.3584516,6.43819355 11.5602581,6.2363871 L14.2379355,3.55870968 L11.9256774,1.24645161 L9.248,3.92412903 C9.04619355,4.12593548 8.72,4.12593548 8.51819355,3.92412903 C8.3163871,3.72232258 8.3163871,3.39612903 8.51819355,3.19432258 L11.5607742,0.151741935 C11.7625806,-0.0500645161 12.0887742,-0.0500645161 12.2905806,0.151741935 L15.3331613,3.19432258 C15.5349677,3.39612903 15.5349677,3.72232258 15.3331613,3.92412903 L12.2905806,6.96670968 C12.1894194,7.06683871 12.0572903,7.11741935 11.9251613,7.11741935 L11.9251613,7.11741935 Z" id="Shape"></path>
                                    <path d="M0.516129032,15.483871 C0.381419355,15.483871 0.249290323,15.4312258 0.151225806,15.3326452 C0.0129032258,15.1943226 -0.0350967742,14.9899355 0.0263225806,14.8046452 L1.51174194,10.3489032 C1.52619355,10.2425806 1.57367742,10.139871 1.65419355,10.0578065 C1.65522581,10.0567742 1.65574194,10.0557419 1.65677419,10.0552258 C1.65729032,10.0547097 1.65729032,10.0541935 1.65780645,10.0541935 L9.2923871,2.41909677 C9.38941935,2.32206452 9.52051613,2.26787097 9.65729032,2.26787097 L9.65729032,2.26787097 C9.79406452,2.26787097 9.92567742,2.32206452 10.0221935,2.41909677 L13.0647742,5.46167742 C13.2665806,5.66348387 13.2665806,5.98967742 13.0647742,6.19148387 L5.45187097,13.8043871 C5.44722581,13.8095484 5.44154839,13.8147097 5.43690323,13.8193548 L5.43070968,13.8255484 C5.3476129,13.9086452 5.24335484,13.9571613 5.13548387,13.972129 L0.679741935,15.4575484 C0.625548387,15.4750968 0.57083871,15.483871 0.516129032,15.483871 L0.516129032,15.483871 Z M2.48825806,10.6828387 L1.33212903,14.1517419 L4.80103226,12.9956129 L11.9700645,5.82658065 L9.65780645,3.51380645 L2.48825806,10.6828387 L2.48825806,10.6828387 Z" id="Shape"></path>
                                </g>
                            </g>
                            <path d="M15,30 C6.729,30 0,23.271 0,15 C0,6.729 6.729,0 15,0 C23.271,0 30,6.729 30,15 C30,23.271 23.271,30 15,30 L15,30 Z M15,2 C7.832,2 2,7.832 2,15 C2,22.168 7.832,28 15,28 C22.168,28 28,22.168 28,15 C28,7.832 22.168,2 15,2 L15,2 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
    </svg>
  );
}


EditIcon.propTypes = {
  className: PropTypes.string
};

export default EditIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/EditIcon/index.js